var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"submit-success"},[_c('van-icon',{attrs:{"name":"checked"}}),_c('div',{staticClass:"submit-success-text"},[_vm._v("提交成功")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }